export enum TipoSetorPropostaEnum {
	Publico = 1,
	Privado = 2
}
